import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IReplaceService = ( createDecorator('replaceService'));
export { IReplaceService };
